import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseListApi } from '@core/models/interfaces/common';
import { GetNotificationsParams, Notifications } from '@core/models/interfaces/notification/notifications';
import { buildHttpParams } from '@shared/utils/buildHttpParams';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private baseUrl = `${environment.API_URL}/crm/notifications`;

  constructor(private httpClient: HttpClient) {}

  getNotificationsForMe(params: GetNotificationsParams) {
    let queryParams = buildHttpParams(params)
    return this.httpClient.get<ResponseListApi<Notifications>>(`${this.baseUrl}/me`, {
      params: queryParams
    });
  }

  markAllAsRead() {
    return this.httpClient.put(`${this.baseUrl}/all-read`, '');
  }

  readNotification(id: string) {
    return this.httpClient.put(`${this.baseUrl}/${id}/read`, '');
  }
}
